export default function formatCityAndCode(
  isRtl: boolean,
  city: string,
  code?: string | null,
): string {
  if (!code) {
    return city;
  }

  return isRtl ? `${code} · ${city}` : `${city} · ${code}`;
}
